/* eslint-disable */
import InlineLoading from '@components/InlineLoading';
import { useAuthRedux } from '@hooks/useAuthRedux';
import { DRAWER_BREAKPOINT } from '@packages/layout/lib/UIShell/context';
import { useApplicationContext } from '@packages/layout/useApplicationContext';
import { createMemo } from '@packages/react';
import React, { useEffect } from 'react';

/**
 *
 * @param Component
 * @param props$
 * @param func$
 * @returns {any}
 * @constructor
 */
export const RenderComponent = (Component, props$: any = {}, func$: any = false) => {
    const [func, props] = typeof props$ === 'boolean' ? [props$, func$] : [func$, props$];

    if (func) {
        return () => RenderComponent(Component);
    }

    if (!React.isValidElement(Component)) {
        Component = <Component {...props} />;
    }

    return Component;
};

interface ProtectedRouteOptions {
    required?: boolean | null;
    redirectURL?: string;
    noSidebar?: boolean;
    noHeader?: boolean;
}

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: ProtectedComponent
 * @date:  29.08.2018
 * @time:  17:45
 * @scope:
 */
export function ProtectedRoute(
    Component: any,
    { required = true, redirectURL = '/sign-up', noSidebar = false, noHeader = false }: ProtectedRouteOptions = {},
) {
    return createMemo(
        (props: any) => {
            const {
                history,
                match: { url },
            } = props;
            const [auth, checking] = useAuthRedux();
            const [, { setDrawer, setDrawerHidden, setHeaderVisibility }] = useApplicationContext();

            useEffect(() => {
                if (!checking) {
                    if (required !== null) {
                        if ((required && !auth) || (!required && auth)) {
                            history.push(`${redirectURL}?u=${encodeURIComponent(url)}`);
                        }
                    }
                }
            }, [checking, auth]);

            useEffect(() => {
                if (noSidebar) {
                    setDrawerHidden(true);
                    setDrawer(false);
                }

                if (noHeader) {
                    setHeaderVisibility(false);
                }

                return () => {
                    if (noSidebar) {
                        if (typeof window !== 'undefined' && window.innerWidth > DRAWER_BREAKPOINT) {
                            setDrawerHidden(false);
                            setDrawer(true);
                        }
                    }

                    if (noHeader) {
                        setHeaderVisibility(true);
                    }
                };
            }, []);

            if (checking) {
                return <InlineLoading />;
            }

            return RenderComponent(Component, props);
        },
        {
            displayName: `ProtectedRoute(${Component.displayName || Component.name || 'Unknown'})`,
        },
    );
}

// function _ProtectedRoutde ( Component, required: boolean | null = true, redirectURL = '/sign-in' ) {
//     class ProtectedComponent extends React.Component {
//         state = {};
//
//         /**
//          * Redirect on mount event
//          */
//         UNSAFE_componentWillMount () {
//             this.redirect(this.props);
//         }
//
//         /**
//          * Redirect on Update
//          * @param nextProps
//          * @param _nextState
//          * @param _ctx
//          */
//         UNSAFE_componentWillUpdate ( nextProps, _nextState, _ctx ) {
//             this.redirect(nextProps);
//         }
//
//         /**
//          * Detect if auth it's _loading
//          * @return {*}
//          */
//         isLoading (): boolean {
//             return getState().Auth.get('loading');
//         }
//
//         /**
//          * Redirect Function
//          * @param props
//          */
//         redirect ( props ) {
//             if ( !this.isLoading() ) {
//                 const { history, match } = props;
//                 const { url } = match;
//
//                 if ( required !== null ) {
//                     if ( ( required && !props.authenticated ) || ( !required && props.authenticated ) ) {
//                         history.push(`${ redirectURL }?u=${ encodeURIComponent(url) }`);
//                     }
//                 }
//             }
//         }
//
//         render () {
//             return RenderComponent(Component, this.props);
//         }
//     }
//
//     return connect({ authenticated: 'Auth.authenticated' })(ProtectedComponent);
// }
